import React from 'react';
import SelectBox from './select-box';

class StatePicker extends React.Component {
  values() {
    return this.refs.selectBox.values();
  }

  componentDidMount() {
    if (window.LOCATION === 'EU') {
      if (!this.props.defaultState) {
        if (this.props.multiple) {
          this.refs.selectBox.setValue(['DNK']);
        } else {
          this.refs.selectBox.setValue('DNK');
        }
      }
    }
  }

  render() {
    const { id, name, style, defaultState, onSelect, multiple } = this.props;
    const stateList = window.statesData || [];

    return (
      <SelectBox
        id={id}
        name={name}
        style={style}
        ref="selectBox"
        valueList={stateList}
        defaultValue={defaultState}
        onSelect={onSelect}
        multiple={multiple}
        defaultString="-- select location --"
      />
    );
  }
}

StatePicker.defaultProps = {
  multiple:  false
};

export default StatePicker;
